import ManagementUpdateAddress from "../../components/ManagementsUpdate/ManagementUpdateAddress/ManagementUpdateAddress";

function ManagementsUpdateAddressPage() {
  return <ManagementUpdateAddress />;
}

export default ManagementsUpdateAddressPage;
